//
export const MyNaviPayPayLogo = {
  /** 公式サイト（https://paypay.ne.jp/merchant-share/logo/）の「ポイントロゴ1」 */
  pppointLogo1: `${process.env.NEXT_PUBLIC_ASSETS_URL}/mynavi/pppoint_logo1_rgb_01.png`,
  /** 公式サイト（https://paypay.ne.jp/merchant-share/logo/）の「ポイントロゴ2」 */
  pppointLogo2: `${process.env.NEXT_PUBLIC_ASSETS_URL}/mynavi/pppoint_logo2_rgb_01.png`,
}
